<template>
	
  <v-container fluid class="container-full-bg-gray">
    <object class="pdf" 
            data="declaracion_responsable_antifraude.pdf"
            width="800"
            height="500">
    </object>
  </v-container>
</template>

<script>
export default {
	name: 'ResponsibleDeclaration',
}
</script>

<style scoped>
  .pdf {
    width: 100%;
    height: 100%;
  }
</style>